const startedWorkflowsList = {
    namespaced: true,
    state: {
        status: "0",
        search: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "starttime" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        workflowStates: {
            0: "Не_запущен",
            1: "Запущен",
            2: "Ожидание",
            3: "Завершен",
            4: "Ошибка",
            5: "Отменен",
            6: "Приостановлен"
        }
    },
    mutations: {
        SET_STATUS (state, payload) {
            state.status = payload;
        },
        SET_TABLE_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getStatus: (s) => s.status,
        getTableSearch: (s) => s.search,
        getTableOptions: (s) => s.tableOptions,
        getWorkflowStates: (s) => s.workflowStates,
    }
}

export default startedWorkflowsList;